import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { FontBold, NormalText } from '../Text/TableText.formats'
import SideModal from '../SideModal/SideModal'

interface IConfirmationModal {
    show: any,
    setShow: any,
    enrollments: any
}

const ViewEnrollementsDetailModal = ({ show, setShow, enrollments }: IConfirmationModal) => {

    return (
        <SideModal
            title='Enrollment Details'
            show={show}
            handleClose={setShow}
            body={
                <>
                    {
                        enrollments?.length > 0 ?
                            enrollments?.map((data: any, index: any) => {
                                return (
                                    <div className='border p-2'>
                                        <div className="mb-2">
                                            <NormalText value="Enrollment Id :" /> <FontBold value={data?.enrollmentId} />
                                        </div>
                                        <div className="mb-2">
                                            <NormalText value="Type :" /> <FontBold value={data?.enrollmentId} />
                                        </div>
                                        <div className="mb-2">
                                            <NormalText value="Instrument :" /> <FontBold value={data?.course?.instrument} />
                                        </div>
                                    </div>
                                )
                            }) :
                            <p>
                                "No Data Found"
                            </p>
                    }
                </>
            }
        />
    )
}

export default ViewEnrollementsDetailModal;